._19euym20 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid #1662C5;
  background: #1662C5;
  color: #FFFFFF;
}
._19euym20:hover {
  border: 1px solid #004493;
  background: #004493;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._19euym20:focus-visible {
  outline-offset: 2px !important;
  outline: 2px solid #1662C5 !important;
  transition: none;
}
._19euym20:active {
  border: 1px solid #002E69;
  background: #002E69;
  box-shadow: none;
}
._19euym20:disabled {
  border: 1px solid #C7C6CA;
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._19euym21 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FFFFFF;
  color: #1662C5;
  border: 1px solid #1662C5;
}
._19euym21:focus {
  color: #1662C5;
  background: #FFFFFF;
  border: 1px solid #1662C5 !important;
  transition: none;
}
._19euym21:active {
  color: #001A41;
  border: 1px solid #002E69 !important;
  background: #ADC6FF;
  box-shadow: none;
}
._19euym21:disabled {
  cursor: not-allowed !important;
  color: #C7C6CA;
  border: 1px solid #C7C6CA;
  background-color: #FFFFFF;
  box-shadow: none;
}
._19euym21:hover:not(:disabled) {
  border: 1px solid #002E69;
  color: #002E69;
  background: #D8E2FF !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._19euym22 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FFFFFF;
  color: #1662C5;
  border: 1px solid #FFFFFF;
  min-width: 25px;
}
._19euym22:focus {
  color: #1662C5;
  background: #FFFFFF;
  border: 1px solid white;
  transition: none;
}
._19euym22:active {
  color: #002E69;
  border: 1px solid #ADC6FF !important;
  background: #ADC6FF !important;
  box-shadow: none;
}
._19euym22:disabled {
  background: #FFFFFF;
  cursor: not-allowed;
  border: 1px solid #FFFFFF;
  color: #C7C6CA;
  box-shadow: none;
}
._19euym22:hover:not(:disabled) {
  color: #004493;
  background: #D8E2FF !important;
  border: 1px solid #D8E2FF !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._19euym23 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FFFFFF;
  color: #BA1A1A;
  border: 1px solid #FFFFFF;
  min-width: 25px;
}
._19euym23:focus {
  color: #BA1A1A;
  background: #FFFFFF;
  border: 1px solid white;
  transition: none;
}
._19euym23:active {
  color: #690004;
  border: 1px solid #FFB4AB !important;
  background: #FFB4AB !important;
  box-shadow: none;
}
._19euym23:disabled {
  background: #FFFFFF;
  cursor: not-allowed;
  border: 1px solid #FFFFFF;
  color: #C7C6CA;
  box-shadow: none;
}
._19euym23:hover:not(:disabled) {
  color: #930009;
  background: #FFDAD5 !important;
  border: 1px solid #FFDAD5 !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._19euym24 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #BA1A1A;
  color: #FFFFFF;
}
._19euym24:hover {
  background: #930009;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._19euym24:focus-visible {
  background: #BA1A1A;
  outline-offset: 2px !important;
  outline: 2px solid #BA1A1A !important;
  transition: none;
}
._19euym24:active {
  background: #690004;
  box-shadow: none;
}
._19euym24:disabled {
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._19euym25 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #EDF0FF;
  color: #1662C5;
}
._19euym25:hover {
  background: #D8E2FF !important;
}
._19euym25:focus {
  background: #FFFFFF;
  border: 1px solid white;
  transition: none;
}
._19euym25:active {
  border: none;
}
._19euym25:disabled {
  background: #FFFFFF;
  cursor: not-allowed;
  border: 1px solid #FFFFFF;
  color: #C7C6CA;
  box-shadow: none;
}
._19euym26 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FEE7EB;
  color: #BA1A1A;
}
._19euym26:hover {
  background: #FFDAD5 !important;
}
._19euym26:focus {
  background: #FFFFFF;
  border: 1px solid white;
  transition: none;
}
._19euym26:active {
  border: none;
}
._19euym26:disabled {
  background: #FFFFFF;
  cursor: not-allowed;
  border: 1px solid #FFFFFF;
  color: #C7C6CA;
  box-shadow: none;
}
._19euym27 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FFECC2;
  color: #815600;
}
._19euym27:hover {
  background: #FFD885 !important;
}
._19euym27:focus {
  background: #FFFFFF;
  border: 1px solid white;
  transition: none;
}
._19euym27:active {
  border: none;
}
._19euym27:disabled {
  background: #FFFFFF;
  cursor: not-allowed;
  border: 1px solid #FFFFFF;
  color: #C7C6CA;
  box-shadow: none;
}
._19euym28 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #CCFFE1;
  color: #006C47;
}
._19euym28:hover {
  background: #B0EFD0 !important;
}
._19euym28:focus {
  background: #FFFFFF;
  border: 1px solid white;
  transition: none;
}
._19euym28:active {
  border: none;
}
._19euym28:disabled {
  background: #FFFFFF;
  cursor: not-allowed;
  border: 1px solid #FFFFFF;
  color: #C7C6CA;
  box-shadow: none;
}
._19euym29 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #D8E2FF;
  color: #001A41;
}
._19euym29:hover {
  background: #D8E2FF;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._19euym29:focus-visible {
  outline-offset: 2px !important;
  outline: 2px solid #1662C5 !important;
  transition: none;
}
._19euym29:disabled {
  border: 1px solid #C7C6CA;
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._19euym2a {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FFDAD5;
  color: #410002;
}
._19euym2a:hover {
  background: #FFDAD5;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._19euym2a:focus-visible {
  outline-offset: 2px !important;
  outline: 2px solid #BA1A1A !important;
  transition: none;
}
._19euym2a:disabled {
  border: 1px solid #C7C6CA;
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._19euym2b {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FFD885;
  color: #291800;
}
._19euym2b:hover {
  background: #FFD885;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._19euym2b:focus-visible {
  outline-offset: 2px !important;
  outline: 2px solid #815600 !important;
  transition: none;
}
._19euym2b:disabled {
  border: 1px solid #C7C6CA;
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._19euym2c {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #B0EFD0;
  color: #002113;
}
._19euym2c:hover {
  background: #B0EFD0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._19euym2c:focus-visible {
  outline-offset: 2px !important;
  outline: 2px solid #006C47 !important;
  transition: none;
}
._19euym2c:disabled {
  border: 1px solid #C7C6CA;
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._19euym2d {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: linear-gradient(90deg, #1662C5, #2DBAD7);
  color: var(--_15pdojo1u);
}
._19euym2d:hover {
  background: linear-gradient(90deg, #004493, #009FB9);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._19euym2d:focus-visible {
  background: linear-gradient(90deg, #1662C5, #2DBAD7);
  outline-offset: 2px !important;
  outline: 2px solid #1662C5 !important;
  transition: none;
}
._19euym2d:active {
  background: linear-gradient(90deg, #002E69, #008399);
  box-shadow: none;
}
._19euym2d:disabled {
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._19euym2e {
  --quiet-bg: transparent;
  --quiet-fg: #1f2937;
  --quiet-border: transparent;
  --quiet-hover-bg: #f3f4f6;
  --quiet-hover-fg: #111827;
  --quiet-active-bg: #e5e7eb;
  --quiet-active-fg: #111827;
  --quiet-focus: #60a5fa;
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--quiet-bg);
  color: var(--quiet-fg);
  border: 1px solid var(--quiet-border);
}
._19euym2e:hover {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._19euym2e:active {
  box-shadow: none;
}
._19euym2e:disabled {
  cursor: not-allowed;
  box-shadow: none;
}
._19euym2e[hidden] {
  display: none;
}
._19euym2e:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
._19euym2e:not(:disabled) {
  cursor: pointer;
}
._19euym2e:focus-visible {
  outline: 2px solid var(--quiet-focus);
  outline-offset: 2px;
}
._19euym2e:not(:disabled):hover {
  background: var(--quiet-hover-bg);
  color: var(--quiet-hover-fg);
}
._19euym2e:not(:disabled):active {
  background: var(--quiet-active-bg);
  color: var(--quiet-active-fg);
}
html.theme-dark ._19euym2e {
  --quiet-bg: transparent;
  --quiet-fg: #e5e7eb;
  --quiet-border: transparent;
  --quiet-hover-bg: rgba(255, 255, 255, 0.08);
  --quiet-hover-fg: #ffffff;
  --quiet-active-bg: rgba(255, 255, 255, 0.12);
  --quiet-active-fg: #ffffff;
  --quiet-focus: #93c5fd;
}
html.theme-dark.button-dark-mode-enabled ._19euym2e:disabled {
  background: transparent;
  color: #5E5E62;
  opacity: 1;
}
html.theme-dark.button-dark-mode-enabled ._19euym20 {
  border: 1px solid #80ABFF;
  background: #80ABFF;
  color: #1B1B1F;
}
html.theme-dark.button-dark-mode-enabled ._19euym20:hover {
  border: 1px solid #4B8EFF;
  background: #4B8EFF;
}
html.theme-dark.button-dark-mode-enabled ._19euym20:focus-visible {
  outline: 2px solid #4B8EFF !important;
}
html.theme-dark.button-dark-mode-enabled ._19euym20:active {
  color: #ADC6FF;
  border: 1px solid transparent;
  background: #002E69;
}
html.theme-dark.button-dark-mode-enabled ._19euym20:disabled {
  color: #919094;
  background: #46464A;
  border: 1px solid #46464A;
}
html.theme-dark.button-dark-mode-enabled ._19euym21 {
  background: transparent;
  color: #ADC6FF;
  border: 1px solid #80ABFF;
}
html.theme-dark.button-dark-mode-enabled ._19euym21:focus-visible {
  color: #ADC6FF;
  background: transparent;
  border: 1px solid #80ABFF !important;
  outline: 1px solid #80ABFF !important;
  outline-offset: 1px !important;
}
html.theme-dark.button-dark-mode-enabled ._19euym21:active {
  border: 1px solid #80ABFF;
  background: #80ABFF;
  color: #1B1B1F;
}
html.theme-dark.button-dark-mode-enabled ._19euym21:disabled {
  color: #5E5E62;
  border: 1px solid #46464A;
  background-color: transparent;
}
html.theme-dark.button-dark-mode-enabled ._19euym21:hover:not(:disabled) {
  border: 1px solid #ADC6FF;
  color: #D8E2FF;
  background: rgba(255, 255, 255, 0.08) !important;
}
html.theme-dark.button-dark-mode-enabled ._19euym22 {
  background: transparent;
  color: #ADC6FF;
  border: 1px solid transparent;
}
html.theme-dark.button-dark-mode-enabled ._19euym22:focus-visible {
  color: #ADC6FF !important;
  background: transparent !important;
}
html.theme-dark.button-dark-mode-enabled ._19euym22:active {
  border: 1px solid #80ABFF !important;
  background: #80ABFF !important;
  color: #1B1B1F;
}
html.theme-dark.button-dark-mode-enabled ._19euym22:disabled {
  background: transparent;
  color: #5E5E62;
}
html.theme-dark.button-dark-mode-enabled ._19euym22:hover:not(:disabled) {
  color: #ADC6FF;
  background: rgba(255, 255, 255, 0.08) !important;
  border: 1px solid transparent !important;
}
html.theme-dark.button-dark-mode-enabled ._19euym24 {
  color: #930009;
  background: #FF897D;
}
html.theme-dark.button-dark-mode-enabled ._19euym24:hover {
  color: #930009;
  background: #FB6156;
}
html.theme-dark.button-dark-mode-enabled ._19euym24:focus-visible {
  color: #930009;
  background: #FF897D;
  outline: 2px solid #FF897D !important;
}
html.theme-dark.button-dark-mode-enabled ._19euym24:active {
  color: #FF897D;
  background: #690004;
  border: 1px solid transparent;
}
html.theme-dark.button-dark-mode-enabled ._19euym24:disabled {
  color: #919094;
  background: #46464A;
}
html.theme-dark.button-dark-mode-enabled ._19euym23 {
  background: transparent;
  color: #FFB4AB;
  border: 1px solid transparent;
}
html.theme-dark.button-dark-mode-enabled ._19euym23:focus {
  color: #FFB4AB;
  background: transparent;
  border: 1px solid #FF897D !important;
}
html.theme-dark.button-dark-mode-enabled ._19euym23:active {
  color: #FF897D !important;
  background: #690004 !important;
  border: 1px solid transparent !important;
}
html.theme-dark.button-dark-mode-enabled ._19euym23:disabled {
  background: transparent;
  color: #5E5E62;
}
html.theme-dark.button-dark-mode-enabled ._19euym23:hover:not(:disabled) {
  color: #FF897D;
  background: #410002 !important;
  border: 1px solid #410002 !important;
}
html.theme-dark.button-dark-mode-enabled ._19euym2d {
  background: linear-gradient(90deg, #4B8EFF, #55D6F4);
  color: #1B1B1F;
}
html.theme-dark.button-dark-mode-enabled ._19euym2d:hover {
  background: linear-gradient(90deg, #1E73E8, #2DBAD7);
}
html.theme-dark.button-dark-mode-enabled ._19euym2d:focus-visible {
  background: linear-gradient(90deg, #4B8EFF, #55D6F4);
  outline: 2px solid #4B8EFF !important;
}
html.theme-dark.button-dark-mode-enabled ._19euym2d:active {
  background: linear-gradient(90deg, #002E69, #004E5C);
  border: none;
}
html.theme-dark.button-dark-mode-enabled ._19euym2d:disabled {
  color: #919094;
  background: #46464A;
}